import { VendorComplianceRequirementItem } from '../types';

export const getRequirementStatusClasses = (status?: string): string => {
  switch (status) {
    case 'Compliant':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300';
    case 'Alert':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300';
    case 'NeedsReview':
      return 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300';
    case 'Missing':
    case 'Rejected':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
  }
};

export const groupRequirementsByCategory = (
  requirements: VendorComplianceRequirementItem[]
): Record<string, VendorComplianceRequirementItem[]> => {
  return requirements.reduce<Record<string, VendorComplianceRequirementItem[]>>((groups, item) => {
    const category = item.category || 'Other';
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(item);
    return groups;
  }, {});
};
